const WEEK = ['日', '一', '二', '三', '四', '五', '六']

/**
 * 日期转字符串
 *
 * @param {any} date
 * @param {string} [formatStr='yyyyMMdd']
 * @returns
 */
const date2Str = (date, formatStr = 'yyyyMMdd') => {
  const fullYear = date.getFullYear()
  const year = date.getYear()
  const month = date.getMonth() + 1
  const day = date.getDay()
  const dt = date.getDate()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  formatStr = formatStr
    .replace(/yyyy|YYYY/, fullYear)
    .replace(/yy|YY/, year > 9 ? (year % 100).toString() : `0${year}`)
    .replace(/MM/, month > 9 ? month.toString() : `0${month}`)
    .replace(/M/g, month)
    .replace(/w|W/g, WEEK[day])
    .replace(/dd|DD/, dt > 9 ? dt.toString() : `0${dt}`)
    .replace(/d|D/g, dt)
    .replace(/hh|HH/, hours > 9 ? hours.toString() : `0${hours}`)
    .replace(/h|H/g, hours)
    .replace(/mm/, minutes > 9 ? minutes.toString() : `0${minutes}`)
    .replace(/m/g, minutes)
    .replace(/ss|SS/, seconds > 9 ? seconds.toString() : `0${seconds}`)
    .replace(/s|S/g, seconds)
  return formatStr
}

/**
 * 获取当前时间字符串
 *
 * @param {string} [formatStr='yyyy/MM/dd hh:mm:ss']
 * @returns
 */
const getTimestamp = (formatStr = 'yyyy/MM/dd hh:mm:ss') => date2Str(new Date(), formatStr)

/**
 * 获取当前日期字符串
 *
 * @param {string} [formatStr='yyyyMMdd']
 * @returns
 */
const getDate = (formatStr = 'yyyyMMdd') => date2Str(new Date(), formatStr)

// YYYYMMDD hh:mm:ss
export const getNowTime = () => {
  const dt = new Date()
  dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset())
  return dt
    .toISOString()
    .replace(/[-]/g, '')
    .replace(/T/g, ' ')
    .substr(0, 17)
}

export const parseNowTime = time => time.replace(/-/g, '')

const getNumberBoxFormatStr = (qu) => {
  const { scoreQuType, scoreQuParagraph } = qu
  let formatStr = ''
  if (scoreQuType === '2') {
    formatStr = 'HH:mm'
  } else if (scoreQuType === '3' && scoreQuParagraph === '1') {
    formatStr = 'yyyy-MM'
  } else if (scoreQuType === '3' && scoreQuParagraph === '2') {
    formatStr = 'yyyy-MM-dd'
  } else if (scoreQuType === '4') {
    formatStr = 'yyyy-MM-dd HH:mm:ss'
  }
  return formatStr
}

export default {
  getDate,
  getTimestamp,
  date2Str,
  getNumberBoxFormatStr
}



// WEBPACK FOOTER //
// ./src/tools/dateUtil.js